/**
 * A hand-off from a public page into Cosmos (Direct Search): "open Cosmos
 * with this industry filter on". Kept in sessionStorage so it survives the
 * sign-in in between (the login modal, or a Google / LinkedIn round trip in
 * the same tab), and used once. Stale after 30 minutes.
 */
const KEY = 'utech_cosmos_seed';
const TTL_MS = 30 * 60 * 1000;

export interface CosmosSeed {
  /** A major industry category, as the tech pages show it. */
  industry?: string;
  /** A university code (utech_university_id): open filtered to it — What's
   *  New's "View new techs →". */
  university?: string;
  source?: string;
}

export function setCosmosSeed(seed: CosmosSeed): void {
  try { sessionStorage.setItem(KEY, JSON.stringify({ ...seed, at: Date.now() })); } catch { /* storage off */ }
}

export function takeCosmosSeed(): CosmosSeed | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const v = JSON.parse(raw);
    if (!v || typeof v !== 'object' || Date.now() - Number(v.at || 0) > TTL_MS) return null;
    return { industry: typeof v.industry === 'string' ? v.industry : undefined,
             university: typeof v.university === 'string' ? v.university : undefined,
             source: typeof v.source === 'string' ? v.source : undefined };
  } catch { return null; }
}
